import { render, staticRenderFns } from "./batchRecharge.vue?vue&type=template&id=371aa33a&"
import script from "./batchRecharge.vue?vue&type=script&lang=js&"
export * from "./batchRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('371aa33a')) {
      api.createRecord('371aa33a', component.options)
    } else {
      api.reload('371aa33a', component.options)
    }
    module.hot.accept("./batchRecharge.vue?vue&type=template&id=371aa33a&", function () {
      api.rerender('371aa33a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userManagement/batchRecharge.vue"
export default component.exports